/**
 * Module front — accès AJAX unifié (Lot 4 d'extraction de demandeur.js, chantier J).
 *
 * Deux objectifs :
 *  1) Normaliser la lecture des réponses serveur, aujourd'hui hétérogène d'un appel à l'autre. Convention
 *     réelle du back OPH : { status: "success" | "failed" | "file_upload_error", message?, errors? }.
 *     Ces lecteurs sont PURS (testés par Jest) — à utiliser en remplacement des `data.status === "..."` inline.
 *  2) Fournir un wrapper `request()` autour de $.ajax qui branche par défaut le handler d'erreur centralisé
 *     (modules/ajax-error) — fin de la redirection /connexion sur erreur, modale + remontée serveur.
 *
 * Migration : les ~23 appels $.ajax existants seront basculés INCRÉMENTALEMENT vers `request()` (chaque
 * bascule à vérifier en navigateur). Ce module est la fondation, sans risque (additif).
 *
 * CommonJS : la partie pure est testable hors navigateur ; le wrapper s'appuie sur jQuery ($, fourni par
 * autoProvidejQuery de Webpack) et n'est exécuté qu'en navigateur.
 */
'use strict';

/** Statut brut de la réponse (chaîne), ou '' si absent. */
function getStatus(data) {
    return (data && typeof data.status === 'string') ? data.status : '';
}

/** La réponse indique-t-elle un succès ? */
function isSuccess(data) {
    return getStatus(data) === 'success';
}

/** La réponse indique-t-elle un échec applicatif (failed, file_upload_error, …) ? */
function isFailure(data) {
    var s = getStatus(data);
    return s !== '' && s !== 'success';
}

/** Message utilisateur de la réponse, ou '' si absent. */
function getMessage(data) {
    return (data && data.message !== undefined && data.message !== null) ? String(data.message) : '';
}

/** Liste d'erreurs normalisée en tableau (gère absent / unique / tableau). */
function getErrors(data) {
    if (!data || data.errors === undefined || data.errors === null) {
        return [];
    }
    return Array.isArray(data.errors) ? data.errors : [data.errors];
}

/**
 * Wrapper $.ajax : applique le handler d'erreur centralisé si l'appelant n'en fournit pas.
 * (Navigateur uniquement — $ est fourni globalement par Webpack/autoProvidejQuery.)
 */
function request(options) {
    var opts = $.extend({}, options || {});
    if (typeof opts.error !== 'function') {
        opts.error = function (err) {
            require('./ajax-error').handleAjaxError(err);
        };
    }
    return $.ajax(opts);
}

module.exports = {
    getStatus: getStatus,
    isSuccess: isSuccess,
    isFailure: isFailure,
    getMessage: getMessage,
    getErrors: getErrors,
    request: request
};
